import useDealersQuery from "../api/use-dealers-query";
import { useSelectedFilterStore } from "../store/filtersv2";
import { DealerData, DealerResponse } from "../types";

export const useDealersStore = () => {
  const { isLoading, isSuccess, data: dealers } = useDealersQuery<DealerResponse, DealerResponse>();
  const { selected } = useSelectedFilterStore();
  const distance = selected.distance || 100;

  const allDealers = dealers?.data;
  const localDealer = dealers?.data[0] as DealerData;
  const dealersWithinRadius = dealers?.data.filter(dealer => dealer.distance <= distance);

  const getDealer = (id: string) => dealers?.data.filter(dealer => dealer.static_dealer_id === id)[0];

  return {
    isLoading,
    isSuccess,
    allDealers,
    localDealer,
    dealersWithinRadius,
    getDealer
  };
};
